export const createFileObject = (textContent) => {
  const blob = new Blob([textContent], { type: "text/plain" });
  const fileObject = new File([blob], `script-${Date.now()}.txt`, {
    type: "text/plain",
  });
  return fileObject;
};
